/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { StaffUserRef } from './StaffUserRef';
import {
    StaffUserRefFromJSON,
    StaffUserRefFromJSONTyped,
    StaffUserRefToJSON,
    StaffUserRefToJSONTyped,
} from './StaffUserRef';
import type { MessageAuthorType } from './MessageAuthorType';
import {
    MessageAuthorTypeFromJSON,
    MessageAuthorTypeFromJSONTyped,
    MessageAuthorTypeToJSON,
    MessageAuthorTypeToJSONTyped,
} from './MessageAuthorType';

/**
 * 
 * @export
 * @interface StaffMessage
 */
export interface StaffMessage {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    participant_id: string;
    /**
     * 
     */
    author_type: MessageAuthorType;
    /**
     * 
     */
    author_user: StaffUserRef | null;
    /**
     * 
     */
    request_item_id: string | null;
    /**
     * 
     */
    in_reply_to_message_id: string | null;
    /**
     * 
     */
    body: string;
    /**
     * 
     */
    acknowledged_at: Date | null;
    /**
     * 
     */
    created_at: Date;
    /**
     * 
     */
    document_ids: Array<string>;
}



/**
 * Check if a given object implements the StaffMessage interface.
 */
export function instanceOfStaffMessage(value: object): value is StaffMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('author_type' in value) || value['author_type'] === undefined) return false;
    if (!('author_user' in value) || value['author_user'] === undefined) return false;
    if (!('request_item_id' in value) || value['request_item_id'] === undefined) return false;
    if (!('in_reply_to_message_id' in value) || value['in_reply_to_message_id'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('acknowledged_at' in value) || value['acknowledged_at'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('document_ids' in value) || value['document_ids'] === undefined) return false;
    return true;
}

export function StaffMessageFromJSON(json: any): StaffMessage {
    return StaffMessageFromJSONTyped(json, false);
}

export function StaffMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'participant_id': json['participant_id'],
        'author_type': MessageAuthorTypeFromJSON(json['author_type']),
        'author_user': StaffUserRefFromJSON(json['author_user']),
        'request_item_id': json['request_item_id'],
        'in_reply_to_message_id': json['in_reply_to_message_id'],
        'body': json['body'],
        'acknowledged_at': (json['acknowledged_at'] == null ? null : parseDateTime(json['acknowledged_at'])),
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'document_ids': json['document_ids'],
    };
}

export function StaffMessageToJSON(json: any): StaffMessage {
    return StaffMessageToJSONTyped(json, false);
}

export function StaffMessageToJSONTyped(value?: StaffMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'participant_id': value['participant_id'],
        'author_type': MessageAuthorTypeToJSON(value['author_type']),
        'author_user': StaffUserRefToJSON(value['author_user']),
        'request_item_id': value['request_item_id'],
        'in_reply_to_message_id': value['in_reply_to_message_id'],
        'body': value['body'],
        'acknowledged_at': value['acknowledged_at'] == null ? value['acknowledged_at'] : serializeDateTime(value['acknowledged_at']),
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'document_ids': value['document_ids'],
    };
}

